import React from 'react'
import { omit } from 'lodash-es'

export const omitProps = (...propNames) => (Component) =>
    React.forwardRef((props, ref) => <Component ref={ref} {...omit(props, propNames)} />)
